import { OVERALL_RESULT_VALUES } from '@/constants/accessor/api/emergencyInspectionResult/emergencyAssessment/overallResult'

/** 総合判定 */
export const OVERALL_RESULT_LABEL = {
  [OVERALL_RESULT_VALUES.RANK_A]: { label: '調査済 (緑)', color: 'bg-success' },
  [OVERALL_RESULT_VALUES.RANK_B]: { label: '要注意 (黄)', color: 'bg-warning' },
  [OVERALL_RESULT_VALUES.RANK_C]: { label: '危険 (赤)', color: 'bg-danger' }
} as const
